import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import Amplify from "aws-amplify";

//============================================================
Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: window.config.AWS_REGION,
    userPoolId: window.config.COGNITO_USER_POOL_ID,
    userPoolWebClientId: window.config.COGNITO_APP_CLIENT_ID
  },
  API: {

    endpoints: [
      {
        name: "digitalforms",
        endpoint: window.config.API_URL,
        region: window.config.AWS_REGION
      }
    ]
  }
});
//============================================================
ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);
registerServiceWorker();
